<template>
  <section class="flex flex-col gap-y-5">
    <card
      v-if="title !== '' || validSlot('title') || validSlot('functions')"
      class="flex flex-row items-center grid grid-cols-2"
    >
      <slot name="title">
        <span :class="titleClass">
          {{ title }}
        </span>
      </slot>
      <slot name="functions"></slot>
    </card>

    <card v-if="validSlot('search')" class="flex flex-row gap-2">
      <slot name="search"></slot>
    </card>

    <!-- Pulse Loading -->
    <section v-if="loading" class="grid" :class="gridClass">
      <card v-for="idx in 12" :key="idx" class="flex flex-col gap-y-4">
        <div class="flex flex-row">
          <div class="w-full flex flex-row gap-x-2">
            <badge
              v-for="idx in 3"
              :key="idx"
              class="animate-pulse dark:bg-slate-700 bg-slate-200 min-w-[4rem] min-h-[1.5rem]"
            ></badge>
          </div>

          <div class="flex flex-row gap-x-2">
            <badge
              type="pill"
              v-for="idx in 2"
              :key="idx"
              class="animate-pulse dark:bg-slate-700 bg-slate-200 min-w-[1.5rem] min-h-[1.5rem]"
            ></badge>
          </div>
        </div>

        <div class="flex flex-col gap-y-2">
          <badge
            type="pill"
            v-for="idx in 4"
            :key="idx"
            class="animate-pulse dark:bg-slate-700 bg-slate-200 min-w-full min-h-[1rem]"
          ></badge>
        </div>
      </card>
    </section>

    <!-- Real Content -->
    <section v-else class="grid" :class="gridClass">
      <router-link
          v-for="(item, idx) in data"
          :key="idx"
          :to="cardLinkFunction(item)"
      >
        <card
            class="flex flex-col gap-y-2"
            :class="cardClass"
            :classes="invertDisabledItemKey != !!item[disabledItemKey] ? disabledCardClasses:abledCardClasses"
            padding="p-4"
        >
          <div class="flex flex-row">
            <div class="w-full flex flex-row gap-x-2">
              <badge color="#64748b">
                #{{ idx + 1 + (pagination.per_page ?? 0) * ((pagination.page ?? 1) - 1) }}
              </badge>
              <slot name="badges" :item="item"></slot>
            </div>

            <div class="flex flex-row-reverse gap-x-2">
              <slot name="actions" :item="item"></slot>
            </div>
          </div>

          <div class="flex flex-col">
            <slot name="info" :item="item"></slot>
          </div>
        </card>
      </router-link>
    </section>

    <section class="flex flex-row justify-center">
      <rpm-pagination :pagination="pagination" @change-page="changePage"></rpm-pagination>
    </section>
  </section>
</template>

<script>

import RpmPagination from "#components/RpmPagination.vue";
import Badge from "#components/Badge.vue";

export default {
  name: "RpmCardList",
  components: {
    RpmPagination,
    Badge,
  },
  data() {
    return {};
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
    title: {
      type: String,
      default: "",
    },
    titleClass: {
      type: String,
      default: "text-md font-bold",
    },
    gridClass: {
      type: String,
      default: "grid-cols-1 gap-4",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabledItemKey: {
      type: String,
      default: "",
    },
    invertDisabledItemKey: {
      type: Boolean,
      default: false,
    },
    disabledCardClasses: {
      type: String,
      default: "",
    },
    abledCardClasses: {
      type: String,
      default: "",
    },
    cardClass: {
      type: String,
      default: "",
    },
    emptyText: {
      type: String,
      default: "Nenhum dado encontrado",
    },
    pagination: {
      type: Object,
      default: {},
    },
    cardLinkFunction: {
      type: Function,
      default: () => ({}),
    },
  },
  methods: {
    validSlot(slot) {
      return !!this.$slots[slot];
    },
    changePage(label) {
      this.$emit("change-page", label);
    }
  },
};
</script>
